<div class="row justify-content-center d-flex create-card-container">
  <div class="card-actions-common-div">
    <div class="card-actions-left width-65">
        <div class="card-actions-left-header-row align-items-center justify-content-between card-actions-header">
          <div class="back-div mt-1 col-lg-4 col-md-4 col-sm-4 d-flex align-items-center">
            <mat-icon (click)="returnToPreviousPage()" class="cursor-pointer">keyboard_arrow_left</mat-icon>
            <span (click)="returnToPreviousPage()" class="cursor-pointer">
              {{'user_card.back_to' | translate }} {{ currentRoute === SharedConstants.TEAMS ? ('user_card.my_teams' | translate) : ('user_card.individual_cards' | translate) }}</span>
          </div>
         <span class="add-content-info">
           <mat-icon [matTooltip]="tooltipText" matTooltipPosition="above"
                     matTooltipClass="custom-tooltip">info_outline</mat-icon>
           {{ 'user_card.subscription_information' | translate }}
         </span>
      </div>
      <div class="card-actions-body mt-30px">
        <div>
          <div class="images-flex flex-wrap justify-content-between">
            <div class="d-flex px-sm-4 mt-3 profilePic flex-direction-column align-items-center">
              <label for="forImage" (click)="imageInput.click()">
                <div id="forImage"
                     class="col-sm-12 text-center image-div image flex-direction-column align-items-center justify-content-center">
                  @if (currentProfileImage || tempProfileImage) {
                    <img [src]="currentProfileImage || 'assets/svg/defaultUserIcon.svg'" alt="" class="image-style">
                  } @else {
                    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M6.41537 26.082C8.05425 24.9801 9.73481 24.1352 11.457 23.5475C13.1793 22.9594 15.0265 22.6654 16.9987 22.6654C18.9709 22.6654 20.8227 22.9594 22.5541 23.5475C24.2858 24.1352 25.9711 24.9801 27.61 26.082C28.7488 24.7023 29.5798 23.2624 30.1029 21.7624C30.6259 20.2624 30.8875 18.6745 30.8875 16.9987C30.8875 13.082 29.5519 9.78801 26.8808 7.11662C24.2094 4.44551 20.9154 3.10995 16.9987 3.10995C13.082 3.10995 9.788 4.44551 7.11662 7.11662C4.4455 9.78801 3.10995 13.082 3.10995 16.9987C3.10995 18.6745 3.37606 20.2624 3.90828 21.7624C4.44078 23.2624 5.27648 24.7023 6.41537 26.082ZM16.9937 18.3874C15.3768 18.3874 14.0149 17.8326 12.9083 16.7229C11.8019 15.6129 11.2487 14.2494 11.2487 12.6325C11.2487 11.0155 11.8037 9.65384 12.9137 8.54745C14.0234 7.44078 15.3868 6.88745 17.0037 6.88745C18.6206 6.88745 19.9825 7.44245 21.0891 8.55245C22.1955 9.66245 22.7487 11.0259 22.7487 12.6429C22.7487 14.2598 22.1937 15.6215 21.0837 16.7279C19.974 17.8343 18.6106 18.3874 16.9937 18.3874ZM16.9874 33.6654C14.6791 33.6654 12.5099 33.2279 10.4799 32.3529C8.44967 31.4779 6.6837 30.2858 5.18203 28.7766C3.68009 27.2672 2.49634 25.5001 1.63078 23.4754C0.764948 21.4506 0.332031 19.2872 0.332031 16.985C0.332031 14.6827 0.769531 12.5191 1.64453 10.4941C2.51953 8.46939 3.71161 6.70703 5.22078 5.20703C6.73023 3.70703 8.49731 2.51953 10.522 1.64453C12.5468 0.769531 14.7102 0.332031 17.0124 0.332031C19.3147 0.332031 21.4783 0.769531 23.5033 1.64453C25.528 2.51953 27.2904 3.70703 28.7904 5.20703C30.2904 6.70703 31.4779 8.47092 32.3529 10.4987C33.2279 12.5265 33.6654 14.6906 33.6654 16.9912C33.6654 19.292 33.2279 21.4541 32.3529 23.4774C31.4779 25.5008 30.2904 27.2672 28.7904 28.7766C27.2904 30.2858 25.5252 31.4779 23.4949 32.3529C21.4649 33.2279 19.2958 33.6654 16.9874 33.6654Z"
                        fill="#6B6C77"/>
                    </svg>
                    <span class="image-div-text">{{ 'user_card.select_image' | translate }}</span>
                  }
                </div>
              </label>
              @if (!isDefaultImage()) {
                <div class="delete-image-button clear-icon" (click)="deleteProfileImage()">
                  <button class="delete-icon-button">
                    <img src="assets/svg/close-icon.svg">
                  </button>
                </div>
              }
              <div class="user-image-edit-bottom">
                <span>{{ 'user_card.card_picture' | translate }}</span>
                <mat-icon [matTooltip]="getIdealDimensionsTooltip('200x200')">info_outline</mat-icon>
              </div>
            </div>
            <input type="file" #imageInput name="profilePic" hidden (change)="onImageChange($event, imageInput)"
                   accept="image/jpeg,image/png">
            <div class="cover-image-div flex-direction-column align-items-center">
              <div class="mt-3 cover-image" (click)="coverImageInput.click()">
                @if (currentCoverImage || tempCoverImage) {
                  <img class="current-image" [src]="currentCoverImage" alt="">
                } @else {
                  <svg width="30" height="30" viewBox="0 0 30 30" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M2.77792 30C2.02792 30 1.37736 29.7246 0.82625 29.1737C0.275417 28.6226 0 27.9721 0 27.2221V2.77792C0 2.02792 0.275417 1.37736 0.82625 0.826251C1.37736 0.275417 2.02792 0 2.77792 0H27.2221C27.9721 0 28.6226 0.275417 29.1737 0.826251C29.7246 1.37736 30 2.02792 30 2.77792V27.2221C30 27.9721 29.7246 28.6226 29.1737 29.1737C28.6226 29.7246 27.9721 30 27.2221 30H2.77792ZM2.77792 27.2221H27.2221V2.77792H2.77792V27.2221ZM4.88875 23.4167H25.1388L18.9721 15.1946L13.6388 22.1667L9.80542 16.9721L4.88875 23.4167Z"
                      fill="#6B6C77"/>
                  </svg>
                  <span class="image-div-text">{{ 'user_card.select_image' | translate }}</span>
                }
              </div>
              <div class="d-flex clear-icon-cover-div">
                @if (currentCoverImage || tempCoverImageUrl) {
                  <div class="delete-image-button clear-icon-cover-edit-or-create" (click)="deleteCoverImage()">
                    <button class="delete-icon-button">
                      <img src="assets/svg/close-icon.svg">
                    </button>
                  </div>
                }
              </div>
              <div class="user-image-edit-bottom">
                <span>{{ 'user_card.cover_photo' | translate }}</span>
                <mat-icon [matTooltip]="getIdealDimensionsTooltip('480x240')">info_outline</mat-icon>
              </div>
            </div>
            <input type="file" #coverImageInput hidden (change)="onCoverImageChange($event, coverImageInput)" accept="image/jpeg,image/png">

            <div class="d-flex px-sm-4 mt-3 companyLogo flex-direction-column align-items-center">
              <label for="forImage1" (click)="companyLogo.click()">
                <div id="forImage1"
                     class="col-sm-12 text-center image-div image flex-direction-column align-items-center justify-content-center">
                  @if (currentCompanyImage || tempCompanyLogo) {
                    <img [src]="currentCompanyImage || 'assets/svg/defaultUserIcon.svg'"
                         alt="" class="image-style">
                  } @else {
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <mask id="mask0_3644_49130" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40"
                            height="40">
                        <rect width="40" height="40" fill="#6B6C77"/>
                      </mask>
                      <g mask="url(#mask0_3644_49130)">
                        <path
                          d="M19.9987 36.6654C17.7118 36.6654 15.5544 36.2279 13.5266 35.3529C11.4988 34.4779 9.73023 33.2858 8.22078 31.7766C6.71161 30.2672 5.51953 28.4986 4.64453 26.4708C3.76953 24.443 3.33203 22.2856 3.33203 19.9987C3.33203 17.6931 3.76953 15.5265 4.64453 13.4987C5.51953 11.4709 6.71161 9.70703 8.22078 8.20703C9.73023 6.70703 11.4988 5.51953 13.5266 4.64453C15.5544 3.76953 17.7118 3.33203 19.9987 3.33203C22.3043 3.33203 24.4709 3.76953 26.4987 4.64453C28.5265 5.51953 30.2904 6.70703 31.7904 8.20703C33.2904 9.70703 34.4779 11.4709 35.3529 13.4987C36.2279 15.5265 36.6654 17.6931 36.6654 19.9987C36.6654 22.2856 36.2279 24.443 35.3529 26.4708C34.4779 28.4986 33.2904 30.2672 31.7904 31.7766C30.2904 33.2858 28.5265 34.4779 26.4987 35.3529C24.4709 36.2279 22.3043 36.6654 19.9987 36.6654ZM19.9987 33.8875C23.869 33.8875 27.1513 32.5356 29.8458 29.832C32.5402 27.1284 33.8875 23.8506 33.8875 19.9987C33.8875 16.1284 32.5402 12.8461 29.8458 10.1516C27.1513 7.45717 23.869 6.10995 19.9987 6.10995C16.1468 6.10995 12.869 7.45717 10.1654 10.1516C7.46175 12.8461 6.10995 16.1284 6.10995 19.9987C6.10995 23.8506 7.46175 27.1284 10.1654 29.832C12.869 32.5356 16.1468 33.8875 19.9987 33.8875ZM13.332 26.6654V21.5404L22.5404 12.3737C22.7904 12.1237 23.0681 11.9431 23.3737 11.832C23.6793 11.7209 23.9848 11.6654 24.2904 11.6654C24.6237 11.6654 24.9431 11.7279 25.2487 11.8529C25.5543 11.9779 25.832 12.1654 26.082 12.4154L27.6237 13.957C27.8645 14.207 28.0427 14.4848 28.1583 14.7904C28.2741 15.0959 28.332 15.4015 28.332 15.707C28.332 16.0126 28.2719 16.3251 28.1516 16.6445C28.0311 16.964 27.8458 17.2487 27.5958 17.4987L18.457 26.6654H13.332ZM15.832 24.1654H17.4154L22.457 19.082L21.707 18.2904L20.9154 17.5404L15.832 22.582V24.1654ZM21.707 18.2904L20.9154 17.5404L22.457 19.082L21.707 18.2904Z"
                          fill="#6B6C77"/>
                      </g>
                    </svg>
                    <span class="image-div-text">{{ 'user_card.select_image' | translate }}</span>
                  }
                </div>
              </label>
              @if (currentCompanyImage || tempCompanyLogo) {
                <div class="delete-image-button clear-icon" (click)="deleteCompanyLogo()">
                  <button class="delete-icon-button">
                    <img src="assets/svg/close-icon.svg">
                  </button>
                </div>
              }
              <div class="user-image-edit-bottom">
                <span>{{ 'user_card.company_logo' | translate }}</span>
                <mat-icon [matTooltip]="getIdealDimensionsTooltip('80x80')">info_outline</mat-icon>
              </div>
            </div>
            <input type="file" #companyLogo name="companyLogo" hidden (change)="onCompanyLogoChange($event, companyLogo)"
                   accept="image/jpeg,image/png">
          </div>

          <div class="mt-50px">
            <form [formGroup]="form" method="post" class="mb-5 py-3 px-sm-4" *ngIf="panelOpenState">

        <div class="form-group d-flex justify-content-between">
          <div class="width-48">
            <app-filled-form-field
              [label]="'user_card.name' | translate"
              [formControlName]="'name'"
              [matTooltip]="isUserCurrentSubscriptionStarter() ? ('user_card.name_surname_editing_restricted' | translate) : ''">
            </app-filled-form-field>
            <div *ngIf="isControlTouchedAndInvalid('name')"
                 class="validation validation-direction">
              <small *ngIf="hasControlRequiredError('name')">
                {{ 'registration_content.enter_name' | translate }}
              </small>
              <small *ngIf="hasControlLengthError('name')"
                     [textContent]="getNameSurnameErrorMessage()"></small>
            </div>
          </div>

          <div class="width-48">
            <app-filled-form-field
              [label]="'user_card.surname' | translate"
              [formControlName]="'surname'"
              [matTooltip]="isUserCurrentSubscriptionStarter() ? ('user_card.name_surname_editing_restricted' | translate) : ''"
              matTooltipClass="custom-tooltip">
            </app-filled-form-field>
            <div *ngIf="isControlTouchedAndInvalid('surname')"
                 class="validation validation-direction">
              <small *ngIf="hasControlRequiredError('surname')">
                {{ 'registration_content.enter_surname' | translate }}
              </small>
              <small *ngIf="hasControlLengthError('surname')"
                     [textContent]="getNameSurnameErrorMessage()"></small>
            </div>
          </div>
        </div>

        <div class="form-group d-flex justify-content-between">
          <div class="width-48">
            <app-filled-form-field [label]="'user_card.job_title'" [formControlName]="'specialization'"></app-filled-form-field>
            <div *ngIf="isControlTouchedAndInvalid('specialization')"
                 class="validation validation-direction">
              <small *ngIf="hasControlRequiredError('specialization')">
                {{ 'user_card.enter_job_title' | translate }}
              </small>
              <small *ngIf="hasControlLengthError('specialization')"
                     [textContent]="getCommonFieldsErrorMessage(fieldsLengthLimit.maxLengthCommon)"></small>
            </div>
          </div>
          <div class="width-48">
            <app-filled-form-field [label]="'user_card.company'" [formControlName]="'company'"></app-filled-form-field>
            <div *ngIf="isControlTouchedAndInvalid('company')"
                 class="validation validation-direction">
              <small *ngIf="hasControlRequiredError('company')">{{ 'user_card.enter_company' | translate }}</small>
              <small *ngIf="hasControlLengthError('company')"
                     [textContent]="getCommonFieldsErrorMessage(fieldsLengthLimit.maxLengthCommon)"></small>
            </div>
          </div>
        </div>

        <div class="form-group d-flex">
          <div class="mr-2 flex-fill">
            <app-filled-form-field [label]="'user_card.location'" [formControlName]="'location'"></app-filled-form-field>
            <div *ngIf="isControlTouchedAndInvalid('location')"
                 class="validation validation-direction">
              <small *ngIf="hasControlRequiredError('location')">{{ 'user_card.enter_location' | translate }}</small>
              <small *ngIf="hasControlLengthError('location')"
                     [textContent]="getCommonFieldsErrorMessage(fieldsLengthLimit.maxLengthCommon)"></small>
            </div>
          </div>
        </div>

        <div class="form-group position-relative">
          <app-filled-form-field [label]="'user_card.bio'" [formControlName]="'about'" type="textarea"></app-filled-form-field>
          <div *ngIf="isControlTouchedAndInvalid('about')"
               class="validation validation-direction">
            <small *ngIf="hasControlRequiredError('about')">{{ 'user_card.enter_bio' | translate }}</small>
            <small *ngIf="hasControlLengthError('about')"
                   [textContent]="getCommonFieldsErrorMessage(fieldsLengthLimit.maxLengthBio)"></small>
          </div>
        </div>

              <div class="form-group">
                <app-scan-multi-select
                  [selectedHashtags]="mappedHashtagsList"
                  [items]="matchingLineHashtags"
                  [maxSelectedItemsCount]="maxLengthConstant.MAX_COUNT_OF_HASHTAGS"
                  bindLabel="name"
                  bindValue="name"
                  formControlName="hashtagList"
                  (click)="search()"
                  (search)="search($event)"
                  (close)="clearMultipleSearchResult()"
                  (loadMore)="loadMore()"
                  [notFoundText]="notFoundText"
                  [label]="multiSelectLabel"
                  [attr.data-debug]="multiSelectLabel"
                  [showSeeMoreButton]="showSeeMoreButton"
                ></app-scan-multi-select>
              </div>
            </form>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="mt-5">
          <div class="flex-direction-row justify-content-between">
            <button class="add-content-button gap-12px" (click)="openAddContentModal()">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_3644_49346)">
                  <rect width="40" height="40" rx="20" fill="#0036B3"/>
                  <path d="M26 20.75H20.75V26H19.25V20.75H14V19.25H19.25V14H20.75V19.25H26V20.75Z" fill="white"/>
                </g>
                <defs>
                  <clipPath id="clip0_3644_49346">
                    <rect width="40" height="40" rx="20" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              <span>{{ 'user_card.add_content' | translate }}</span>
            </button>

            <div class="flex-direction-row-card-toggles align-items-center justify-content-between">
              <app-toggle
                class="mx-2 row-first-toggle"
                (onChange)="isSingleLink = $event"
                [inputId]="'single-link-1'"
                [data]="ToggleElModel.create({id: 1, leftText: 'user_card.single_link', readonly: isSingleLinkToggleActive(), selected: isSingleLink})">
              </app-toggle>

              <app-toggle
                (onChange)="isContentViewGrid = $event"
                [inputId]="'content-highlight-1'"
                [data]="ToggleElModel.create({ id: 2, leftText: 'user_card.content_highlight', readonly: isContentHighlightToggleActive(),  selected: isContentViewGrid})">
              </app-toggle>
            </div>
          </div>

          <div class="content-body">
            <div class="w-100 pb-4 mt-3 d-flex flex-wrap" *ngIf="userCardContentRequest.length > 0">
              <div cdkDropList (cdkDropListDropped)="drop($event)" class="w-100">
                @for (userCardContent of userCardContentRequest; track userCardContent) {
                  @if (!isSingleLink) {
                    <div>
                      <div cdkDrag class="single-user-card-content ms-3 d-flex align-items-center">
                        <div cdkDragHandle class="drag-handle">
                          <img src="assets/svg/new-drag-and-drop-icon.svg" alt="Drag and drop icon"
                               class="drag-and-drop-icon">
                        </div>
                        <div class="size-fixed"
                             (click)="openEditContentModal(userCardContent)">
                          <img [src]="getContentIcon(userCardContent.contentIcon)" class="icon-style" alt="">
                        </div>
                        <span
                          (click)="openEditContentModal(userCardContent)"
                          class="content-text">{{ userCardContent.linkTitle ? userCardContent.linkTitle : userCardContent.contentName }}
              </span>
                        <div class="toggle-div d-flex">
                          <app-toggle (onChange)="updateActiveState(userCardContent)"
                                      [inputId]="userCardContent.id + userCardContent.contentName + userCardContent.identifier + 'single-content-link'"
                                      [data]="ToggleElModel.create({id: userCardContent.id,
                      readonly: shouldBeDisabled(userCardContent),
                      selected: userCardContent.active})">
                          </app-toggle>
                          <div class="delete-content-edit delete-content-icon user-card-content-delete-button-position"
                               [ngClass]="!userCardContent.active ? 'd-block me-2' : 'd-none' "
                               (click)="deleteUserCardContent(userCardContent)">
                            <button class="delete-icon-button">
                              <img src="assets/svg/close-icon.svg">
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  } @else {
                    @if (userCardContent.active) {
                      <div
                        [ngClass]="!userCardContent.singleLink ? 'single-user-card-single-content ms-3 d-flex align-items-center w-100' : 'single-user-card-content-single single ms-3 d-flex align-items-center w-100' ">
                        <div [ngClass]="!userCardContent.singleLink ? 'size-fixed opacity-50' : 'size-fixed'">
                          <img class="icon-style" [src]="getContentIcon(userCardContent.contentIcon)" alt="">
                        </div>
                        <span [ngClass]="!userCardContent.singleLink ? 'content-text opacity-50' : 'content-text'">{{
                            userCardContent.linkTitle ? userCardContent.linkTitle : userCardContent.contentName
                          }}</span>
                        <div class="toggle-div d-flex">
                          @if (isSingleLink && !userCardContent.singleLink && userCardContent.type != ContentType.DOCUMENT) {
                            <button class="make-direct-button"
                                    (click)="makeContentLinkSingleByContentId(userCardContent.id, userCardContent.identifier)">
                              {{ 'user_card.make_direct' | translate }}
                            </button>
                          }
                        </div>
                      </div>
                    }
                  }
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="width-100 d-flex justify-content-end save-cancel-div">
        <button class="me-2 bb-style mt-1 col-lg-2 col-md-5 col-sm-6 col-6"
                (click)="returnToPreviousPage()"
                [ngClass]="form.valid ? 'bb-style-inactive' : 'bb-style'">{{ 'user_card.cancel' | translate }}
        </button>
        <button type="submit" class="filled-button mt-1 col-lg-2 col-md-5 col-sm-6 col-6"
                (click)="editCard()"
                [disabled]="isEditButtonInactive || !form.valid"
                [ngClass]="!isEditButtonInactive && form.valid ? 'filled-button short-button' : 'filled-inactive-button short-button'">{{ 'user_card.save' | translate }}
        </button>
      </div>
    </div>

    <div class="card-actions-right width-35">
      <app-card-live-preview
        [backgroundImage]="currentCoverImage || '/assets/images/defBackgroundImage.png'"
        [profilePicture]="currentProfileImage || 'assets/svg/defaultUserIcon.svg'"
        [companyLogo]="currentCompanyImage || null"
        [fullName]="form.get('name')?.value + ' ' + form.get('surname')?.value"
        [description]="form.get('about')?.value"
        [location]="form.get('location')?.value"
        [specialization]="form.get('specialization')?.value"
        [company]="form.get('company')?.value"
        [hashtagsList]="form.get('hashtagList')?.value"
        [contentList]="userCardContentRequest"
        [isContentViewGrid]="isContentViewGrid"
        [isSingleLink]="isSingleLink"
      ></app-card-live-preview>
    </div>
  </div>
</div>
<ng-template #accountCircle>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.023 15.2923C4.873 14.6616 5.799 14.1635 6.801 13.798C7.80283 13.4327 8.86917 13.25 10 13.25C11.1308 13.25 12.1972 13.4327 13.199 13.798C14.201 14.1635 15.127 14.6616 15.977 15.2923C16.5987 14.6089 17.0912 13.8179 17.4548 12.9192C17.8183 12.0206 18 11.0475 18 10C18 7.78333 17.2208 5.89583 15.6625 4.3375C14.1042 2.77917 12.2167 2 10 2C7.78333 2 5.89583 2.77917 4.3375 4.3375C2.77917 5.89583 2 7.78333 2 10C2 11.0475 2.18175 12.0206 2.54525 12.9192C2.90875 13.8179 3.40133 14.6089 4.023 15.2923ZM10 10.75C9.08717 10.75 8.31733 10.4365 7.6905 9.8095C7.0635 9.18267 6.75 8.41283 6.75 7.5C6.75 6.58717 7.0635 5.81733 7.6905 5.1905C8.31733 4.5635 9.08717 4.25 10 4.25C10.9128 4.25 11.6827 4.5635 12.3095 5.1905C12.9365 5.81733 13.25 6.58717 13.25 7.5C13.25 8.41283 12.9365 9.18267 12.3095 9.8095C11.6827 10.4365 10.9128 10.75 10 10.75ZM10 19.5C8.68083 19.5 7.44333 19.2519 6.2875 18.7558C5.13167 18.2596 4.12625 17.5839 3.27125 16.7288C2.41608 15.8738 1.74042 14.8683 1.24425 13.7125C0.748083 12.5567 0.5 11.3192 0.5 10C0.5 8.68083 0.748083 7.44333 1.24425 6.2875C1.74042 5.13167 2.41608 4.12625 3.27125 3.27125C4.12625 2.41608 5.13167 1.74042 6.2875 1.24425C7.44333 0.748084 8.68083 0.5 10 0.5C11.3192 0.5 12.5567 0.748084 13.7125 1.24425C14.8683 1.74042 15.8738 2.41608 16.7288 3.27125C17.5839 4.12625 18.2596 5.13167 18.7558 6.2875C19.2519 7.44333 19.5 8.68083 19.5 10C19.5 11.3192 19.2519 12.5567 18.7558 13.7125C18.2596 14.8683 17.5839 15.8738 16.7288 16.7288C15.8738 17.5839 14.8683 18.2596 13.7125 18.7558C12.5567 19.2519 11.3192 19.5 10 19.5Z"
      fill="#12314F"/>
  </svg>
</ng-template>
<ng-template #accountCircleActive>
  <svg width="20" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.523 15.2923C4.373 14.6616 5.299 14.1635 6.301 13.798C7.30283 13.4327 8.36917 13.25 9.5 13.25C10.6308 13.25 11.6972 13.4327 12.699 13.798C13.701 14.1635 14.627 14.6616 15.477 15.2923C16.0987 14.6089 16.5912 13.8179 16.9548 12.9192C17.3183 12.0206 17.5 11.0475 17.5 10C17.5 7.78333 16.7208 5.89583 15.1625 4.3375C13.6042 2.77917 11.7167 2 9.5 2C7.28333 2 5.39583 2.77917 3.8375 4.3375C2.27917 5.89583 1.5 7.78333 1.5 10C1.5 11.0475 1.68175 12.0206 2.04525 12.9192C2.40875 13.8179 2.90133 14.6089 3.523 15.2923ZM9.50025 10.75C8.58725 10.75 7.81733 10.4367 7.1905 9.81C6.5635 9.18317 6.25 8.41325 6.25 7.50025C6.25 6.58725 6.56333 5.81733 7.19 5.1905C7.81683 4.5635 8.58675 4.25 9.49975 4.25C10.4128 4.25 11.1827 4.56333 11.8095 5.19C12.4365 5.81683 12.75 6.58675 12.75 7.49975C12.75 8.41275 12.4367 9.18267 11.81 9.8095C11.1832 10.4365 10.4133 10.75 9.50025 10.75ZM9.5 19.5C8.18083 19.5 6.94333 19.2519 5.7875 18.7558C4.63167 18.2596 3.62625 17.5839 2.77125 16.7288C1.91608 15.8738 1.24042 14.8683 0.74425 13.7125C0.248083 12.5567 0 11.3192 0 10C0 8.68083 0.248083 7.44333 0.74425 6.2875C1.24042 5.13167 1.91608 4.12625 2.77125 3.27125C3.62625 2.41608 4.63167 1.74042 5.7875 1.24425C6.94333 0.748084 8.18083 0.5 9.5 0.5C10.8192 0.5 12.0567 0.748084 13.2125 1.24425C14.3683 1.74042 15.3738 2.41608 16.2288 3.27125C17.0839 4.12625 17.7596 5.13167 18.2558 6.2875C18.7519 7.44333 19 8.68083 19 10C19 11.3192 18.7519 12.5567 18.2558 13.7125C17.7596 14.8683 17.0839 15.8738 16.2288 16.7288C15.3738 17.5839 14.3683 18.2596 13.2125 18.7558C12.0567 19.2519 10.8192 19.5 9.5 19.5ZM9.5 18C10.4025 18 11.2727 17.8548 12.1105 17.5645C12.9483 17.274 13.6923 16.8679 14.3422 16.3462C13.6923 15.8436 12.958 15.4519 12.1395 15.1712C11.3208 14.8904 10.441 14.75 9.5 14.75C8.559 14.75 7.67758 14.8888 6.85575 15.1663C6.03392 15.4439 5.30125 15.8372 4.65775 16.3462C5.30775 16.8679 6.05167 17.274 6.8895 17.5645C7.72733 17.8548 8.5975 18 9.5 18ZM9.5 9.25C9.9975 9.25 10.4135 9.08267 10.748 8.748C11.0827 8.4135 11.25 7.9975 11.25 7.5C11.25 7.0025 11.0827 6.5865 10.748 6.252C10.4135 5.91733 9.9975 5.75 9.5 5.75C9.0025 5.75 8.5865 5.91733 8.252 6.252C7.91733 6.5865 7.75 7.0025 7.75 7.5C7.75 7.9975 7.91733 8.4135 8.252 8.748C8.5865 9.08267 9.0025 9.25 9.5 9.25Z"
      fill="#12314F"/>
  </svg>
</ng-template>
<ng-template #apps>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14C0 13.45 0.195833 12.9792 0.5875 12.5875C0.979167 12.1958 1.45 12 2 12C2.55 12 3.02083 12.1958 3.4125 12.5875C3.80417 12.9792 4 13.45 4 14C4 14.55 3.80417 15.0208 3.4125 15.4125C3.02083 15.8042 2.55 16 2 16ZM8 16C7.45 16 6.97917 15.8042 6.5875 15.4125C6.19583 15.0208 6 14.55 6 14C6 13.45 6.19583 12.9792 6.5875 12.5875C6.97917 12.1958 7.45 12 8 12C8.55 12 9.02083 12.1958 9.4125 12.5875C9.80417 12.9792 10 13.45 10 14C10 14.55 9.80417 15.0208 9.4125 15.4125C9.02083 15.8042 8.55 16 8 16ZM14 16C13.45 16 12.9792 15.8042 12.5875 15.4125C12.1958 15.0208 12 14.55 12 14C12 13.45 12.1958 12.9792 12.5875 12.5875C12.9792 12.1958 13.45 12 14 12C14.55 12 15.0208 12.1958 15.4125 12.5875C15.8042 12.9792 16 13.45 16 14C16 14.55 15.8042 15.0208 15.4125 15.4125C15.0208 15.8042 14.55 16 14 16ZM2 10C1.45 10 0.979167 9.80417 0.5875 9.4125C0.195833 9.02083 0 8.55 0 8C0 7.45 0.195833 6.97917 0.5875 6.5875C0.979167 6.19583 1.45 6 2 6C2.55 6 3.02083 6.19583 3.4125 6.5875C3.80417 6.97917 4 7.45 4 8C4 8.55 3.80417 9.02083 3.4125 9.4125C3.02083 9.80417 2.55 10 2 10ZM8 10C7.45 10 6.97917 9.80417 6.5875 9.4125C6.19583 9.02083 6 8.55 6 8C6 7.45 6.19583 6.97917 6.5875 6.5875C6.97917 6.19583 7.45 6 8 6C8.55 6 9.02083 6.19583 9.4125 6.5875C9.80417 6.97917 10 7.45 10 8C10 8.55 9.80417 9.02083 9.4125 9.4125C9.02083 9.80417 8.55 10 8 10ZM14 10C13.45 10 12.9792 9.80417 12.5875 9.4125C12.1958 9.02083 12 8.55 12 8C12 7.45 12.1958 6.97917 12.5875 6.5875C12.9792 6.19583 13.45 6 14 6C14.55 6 15.0208 6.19583 15.4125 6.5875C15.8042 6.97917 16 7.45 16 8C16 8.55 15.8042 9.02083 15.4125 9.4125C15.0208 9.80417 14.55 10 14 10ZM2 4C1.45 4 0.979167 3.80417 0.5875 3.4125C0.195833 3.02083 0 2.55 0 2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0C2.55 0 3.02083 0.195833 3.4125 0.5875C3.80417 0.979167 4 1.45 4 2C4 2.55 3.80417 3.02083 3.4125 3.4125C3.02083 3.80417 2.55 4 2 4ZM8 4C7.45 4 6.97917 3.80417 6.5875 3.4125C6.19583 3.02083 6 2.55 6 2C6 1.45 6.19583 0.979167 6.5875 0.5875C6.97917 0.195833 7.45 0 8 0C8.55 0 9.02083 0.195833 9.4125 0.5875C9.80417 0.979167 10 1.45 10 2C10 2.55 9.80417 3.02083 9.4125 3.4125C9.02083 3.80417 8.55 4 8 4ZM14 4C13.45 4 12.9792 3.80417 12.5875 3.4125C12.1958 3.02083 12 2.55 12 2C12 1.45 12.1958 0.979167 12.5875 0.5875C12.9792 0.195833 13.45 0 14 0C14.55 0 15.0208 0.195833 15.4125 0.5875C15.8042 0.979167 16 1.45 16 2C16 2.55 15.8042 3.02083 15.4125 3.4125C15.0208 3.80417 14.55 4 14 4Z"
      fill="#12314F"/>
  </svg>
</ng-template>
<div class="common-footer">
      <div class="width-100 d-flex justify-content-center flex-direction-column gap-10px">
        <button class="me-2 bb-style mt-1 width-100"
                (click)="returnToPreviousPage()"
                [ngClass]="form.valid ? 'bb-style-inactive' : 'bb-style'">{{ 'user_card.cancel' | translate }}
        </button>
        <button type="submit" class="filled-button mt-1 width-100"
                (click)="editCard()"
                [disabled]="isEditButtonInactive || form.invalid"
                [ngClass]="!isEditButtonInactive && form.valid ? 'filled-button short-button' : 'filled-inactive-button short-button'">{{ 'user_card.save' | translate }}
        </button>

        <div class="mt-3 width-100 align-items-center d-flex justify-content-center">
          <mat-icon (click)="returnToPreviousPage()" class="cursor-pointer">keyboard_arrow_left</mat-icon>
          <span (click)="returnToPreviousPage()" class="cursor-pointer">
                {{'user_card.back_to' | translate }} {{ currentRoute === SharedConstants.TEAMS ? ('user_card.my_teams' | translate) : ('user_card.individual_cards' | translate) }}</span>
        </div>
      </div>
</div>
